<template>
  <v-layout row wrap>
    <v-flex xs12>
      <div v-if="userInfoLoading" class="text-xs-center">
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
        <div>
          <span>Retrieving user info</span>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMutations } from "vuex"
import jwtDecode from "jwt-decode"
import AppService from "@/AppService"
import * as appDataService from "@/AppDataService"
import * as authDataService from "@/Auth/AuthDataService"
import { SET_CABLE_USER_INFO } from "@/store/constants/mutation-types"

export default {
  name: "SSO",
  data() {
    return {
      userInfoLoading: true
    }
  },
  methods: {
    ...mapMutations([
      SET_CABLE_USER_INFO
    ]),
    loadCableUserInfo(authCode) {
      let tokenInfo = {}
      let accessToken = ""
      let refreshToken = ""
      let idToken = ""
      let idTokenParsed = {}

      if (!this.$lodash.isUndefined(authCode)) {
        //  User is coming here after getting temporary auth code
        //  Retrive token information and user information
        this.userInfoLoading = true
        authDataService
          .getSSOToken(authCode)
          .then((tokenInforesponse) => {
            tokenInfo = tokenInforesponse.data
            accessToken = tokenInfo.access_token
            idToken = tokenInfo.id_token
            refreshToken = tokenInfo.refresh_token
            idTokenParsed = jwtDecode(idToken)
            return authDataService.getSSOAPIToken(idToken, refreshToken)
          })
          .then((apiTokenResponse) => {
            let userObject = this.$lodash.merge(tokenInfo, {
              "comcast_email": idTokenParsed.email,
              "access_token_api": apiTokenResponse.data.access_token
            })
            appDataService.setCableUserInfo(userObject)
              .then((userObject) => {
                this.SET_CABLE_USER_INFO(userObject)
                AppService.$emit("event:cableLoginSuccess", userObject)
                // Redirect user
                appDataService.getRedirectPath().then((pathName) => {
                  if (!this.$lodash.isUndefined(pathName) && !this.$lodash.isEmpty(pathName)) {
                    this.$router.push({
                      name: pathName
                    })
                  } else {
                    this.$router.push({
                      name: "Home"
                    })
                  }
                })
              })
          })
          .catch((error) => {
            this.SET_CABLE_USER_INFO({})
            AppService.$emit("event:cableLoginFailure", error)
          })
          .finally(() => {
            this.userInfoLoading = false
          })
      } else {
        this.$router.go(-1)
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let authCode = to.query.code
      vm.loadCableUserInfo(authCode)
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/Auth/SSO.vue